import { Component, OnInit, HostListener, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { Observable } from 'rxjs';
import { ChangeIssuerService } from './change-issuer.service';
import { PArray } from '../shared/packit-array';
import { PackagingMaterialListBE, PackagingMaterialBE } from '../../app/packaging-material/shared/packaging-material.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { PackagingMaterialService } from '../../app/packaging-material/packaging-material.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { PackageInstructionAdditionalMHBE } from '../../app/packaging-instruction/shared/packaging-instruction-material.model';

import { DistributionUnitService } from '../distribution-unit/distribution-unit.service';
import { DistributionUnitBE, DUAdditionalInfoBe, DuData } from '../distribution-unit/shared/distribution-unit.model';
import { AttributeListBE } from '../shared/attribute-list.model';

import { PackageInstructionService } from '../packaging-instruction/packaging-instruction.service';
import { PackageInstructionItem, PackageIntructionPart } from '../packaging-instruction/shared/packaging-instruction.model';
import { UserHandling } from '../shared/user-handling';
import { NgbDateStruct, NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SequenceInstructionService } from '../sequence-instruction/sequence-instruction.service';
import { SequenceInstructionItem, SequenceInstructionPart } from '../sequence-instruction/shared/sequence-instruction.model';
import { ChineseChangeValueService } from '../chinese-change-value.service';


interface allTables {
  value: string;
  viewValue: string;
}

@Component({
  //changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-change-issuer',
  templateUrl: './change-issuer.component.html',
  styleUrls: ['./change-issuer.component.css'],
  providers: [ChangeIssuerService, PackageInstructionService, PackagingMaterialService, DistributionUnitService, SequenceInstructionService]
})
export class ChangeIssuerComponent implements OnInit, ComponentCanDeactivate {

  isDirty: boolean = false;
  // showPartSearchSpinner = false;
  searchInDescription = false;
  options;

  global: any = {};
  selectedValue = "global" ;

  issuer = true;
  isEdited: boolean;
  isApproved: boolean;
  oldIssuerUserId: string;
  OldApproverUserId: string;

  //PI
  selectedInstructionId: number = -1;
  pendingAction: any = null;
  instruction: PackageInstructionItem = null;
  instructionsList: AttributeListBE[];
  fetchDataFunctionPI: any = (searchTerm: string) => { this.loadInstructionList(searchTerm); };
  user: UserHandling = new UserHandling();
  nameExistsClass: string = "";
  startDate: NgbDateStruct;
  createDate: NgbDateStruct;
  dialogAction: string;
  dialogBtnType: string;
  dialogAppliesTo: string = "";
  dialogAppliesToId: number = -1;
  currentDlg: NgbModalRef;
  @ViewChild('cDlg') cdlg: ElementRef;




  //PM
  searchMaterialText: string = '';
  typeDelayTimer: any = null;
  searchKeyStrokeDelay: number = 350;
  materialSearchResult: PArray<PackagingMaterialListBE> = new PArray(new Array<PackagingMaterialListBE>());
  selectedMaterialsPArr: PArray<PackagingMaterialListBE> = new PArray(new Array<PackagingMaterialListBE>());
  isAlreadyAddedPArr: PArray<PackageInstructionAdditionalMHBE> = null;
  showMaterialSearchSpinner: boolean = false;
  errorObj: ErrorObject = null;
  showCheckBoxes: boolean = false;
  showRadios: boolean = false;
  material: PackagingMaterialBE = null;
  selectedMaterialId: number;
  showLoadAttributeListsSpinner: boolean = false;
  isEditMode: boolean = false;


  //DU
  showSpinner = false;
  selectedDistrUnitId: number = -1;
  distrUnit: DistributionUnitBE;
  viewDUList: boolean = false;
  distrUnitList: AttributeListBE[];
  fetchDataFunction: any = (searchParam: string) => { this.loadDistrUnitList(searchParam) };
  confirmDlgText = "";
  newInstructionText: string = null;


  //SI
  seqinstruction: SequenceInstructionItem = null;
  fetchDataFunctionSI: any = (searchTerm: string) => { this.loadSeqInstructionList(searchTerm); };
  selectedseqInstructionId: number = -1;


  allTables: allTables[] = [
    { value: 'global', viewValue: 'Everywhere' },
    { value: 'PI', viewValue: 'Packaging Instruction' },
    { value: 'PM', viewValue: 'Packaging Material' },
    { value: 'DU', viewValue: 'Distribution Unit' },
    { value: 'SI', viewValue: 'Sequence Instruction'}
  ];

  constructor(private changeIssuerService: ChangeIssuerService,
    private packInstrService: PackageInstructionService,
    private seqInstrService: SequenceInstructionService,
    private modalService: NgbModal,
    private materialService: PackagingMaterialService,
    private distUnitService: DistributionUnitService,
    private errHandler: ErrorHandlerService,
    private cdRef: ChangeDetectorRef,
    public ChineseChangeValueService:ChineseChangeValueService) {
    this.options = 0;

  }

  ngAfterViewChecked() {

    this.cdRef.detectChanges();
  }

  ngOnInit() {

    this.reset_filter();
  }


  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }

  reset_filter() {
    this.material = null;
    this.instruction = null;
    this.seqinstruction = null;
    this.distrUnit = null;
    this.global.oldUser = null;
    this.global.newUser = null;
  }

  loggedInUser = this.user.UserId;


  //Packaging Instruction
  openInstruction(piId: number) {
    this.selectedInstructionId = piId;
    this.pendingAction = this.loadPi;
    this.pendingAction();
  }



  loadPi: any = () => {
    this.pendingAction = null;
    this.loadInstruction();
  }

  loadInstruction() {
    this.showSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);

    this.packInstrService.getInstruction(this.selectedInstructionId)
      .subscribe(returnObject => this.loadInstructionResponse(returnObject));
  }

  loadInstructionResponse(returnObject: IReturnObject) {
    this.instruction = null;
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadInstructionResponse', returnObject.ErrorType);

    this.setLoadedValuesPI(returnObject);
  }

  setLoadedValuesPI(returnObject: IReturnObject) {
    this.selectedInstructionId = returnObject.DataList[0].Id;
    this.instruction = <PackageInstructionItem>returnObject.DataList[0];
    this.instruction.Parts = <PackageIntructionPart[]>returnObject.DataList[0].Parts;
    this.showSpinner = false;
    this.isDirty = false;


  }

  loadInstructionList(searchTerm: string) {
    this.instructionsList = null;
    this.packInstrService.getInstructionList(searchTerm, this.user.SupplierNumber, this.user.ExtendedSupplierNumber, this.user.IsPartSupplierUser, this.user.InstructionType)
      .subscribe(returnObject => this.loadInstructionListResponse(returnObject));
  }

  loadInstructionListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadInstructionListResponse', ErrorTypeEnum.Error);
    }
    else {
      this.instructionsList = <AttributeListBE[]>returnObject.DataList;
    }
  }

  setDirty() {
    this.isDirty = true;
  }

  setDefaultBackColor() {
    this.nameExistsClass = "";
  }


  //Packaging Material

  onSearchMaterialExecute(materialId: number) {
    this.showMaterialSearchSpinner = true;
    this.selectedMaterialId = materialId;
    this.getMaterial(materialId);
    this.setEditMode(true);


  }

  getMaterial(materialId: number) {
    this.errHandler.emitErrorObject(null);
    this.setEditMode(true);

    this.materialService.getMaterial(materialId)
      .subscribe(returnObject => this.getMaterialResponse(returnObject));
  }

  setEditMode(editMode: boolean) {
    this.material = null;
    this.isEditMode = editMode;

  }

  getMaterialResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingMaterialComponent.searchMaterialResponse', returnObject.ErrorType);
    else
      this.setLoadedValuesPM(returnObject);

    this.showMaterialSearchSpinner = false;
  }

  setLoadedValuesPM(returnObject: IReturnObject) {
    this.selectedMaterialId = returnObject.DataList[0].Id;
    this.material = <PackagingMaterialBE>returnObject.DataList[0];

  }




  //Distribution Unit
  isSearchHidden() {
    return false;
  }

  isAtLeastOneDu(): boolean {
    return this.distrUnit.Material != null && this.distrUnit.Material.MHNo.length > 0;
  }

  loadIDistrUnit(duId: number) {
    this.showSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.selectedDistrUnitId = duId;

    this.distUnitService.getDistrUnit(duId)
      .subscribe(returnObject => this.loadDistrUnitResponse(returnObject));
  }

  loadDistrUnitResponse(returnObject: IReturnObject) {
    this.distrUnit = new DistributionUnitBE;
    if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.loadDistrUnitResponse',
        returnObject.ErrorType);
    } else {
      this.selectedDistrUnitId = returnObject.DataList[0].Id;
      this.distrUnit = <DistributionUnitBE>returnObject.DataList[0];
      this.viewDUList = false;
      this.setLoadedValues(returnObject);

      if (this.distrUnit.DUMaterial.length < 0) {
        const main = new DUAdditionalInfoBe();
        main.MHNo = this.distrUnit.Material.MHNo;
        main.Description = this.distrUnit.Material.Description;
        main.Id = this.distrUnit.Material.Id;
        main.Weight = this.distrUnit.Material.Weight;
        this.distrUnit.DUMaterial.push(main);
      }

      this.newInstructionText = null;
    }

    this.showSpinner = false;
    this.viewDUList = false;
    this.isDirty = false;
  }

  setLoadedValues(returnObject: IReturnObject) {
    if (this.distrUnit.IssuerUserId == null || this.distrUnit.IssuerUserId.length < 6) {
      this.distrUnit.IssuerUserId = this.user.UserId;
      this.distrUnit.IssuerName = this.user.UserName;
      this.distrUnit.IssuerDepartment = this.user.Department;
    }


  }




  loadDistrUnitList(searchParam: string) {
    this.distrUnitList = null;
    clearInterval(this.typeDelayTimer);

    this.distUnitService.getDistrUnitList(searchParam)
      .subscribe(returnObject => this.loadDistrUnitListResponse(returnObject));
  }

  loadDistrUnitListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.loadDistrUnitListResponse',
        ErrorTypeEnum.Error);
    } else {
      this.distrUnitList = <AttributeListBE[]>returnObject.DataList;

    }
  }


  //Sequence Instruction
  openSeqInstruction(siId: number) {
    this.selectedseqInstructionId = siId;
    this.pendingAction = this.loadSi;
    this.pendingAction();
  }

  loadSi: any = () => {
    this.pendingAction = null;
    this.loadSeqInstruction();
  }

  loadSeqInstruction() {
    this.showSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);

    this.seqInstrService.getInstruction(this.selectedseqInstructionId)
      .subscribe(returnObject => this.loadSeqInstructionResponse(returnObject));
  }

  loadSeqInstructionResponse(returnObject: IReturnObject) {
    this.seqinstruction = null;
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequenceInstructionComponent.loadSeqInstructionResponse', returnObject.ErrorType);

    this.setLoadedValuesSI(returnObject);
  }

  setLoadedValuesSI(returnObject: IReturnObject) {
    this.selectedInstructionId = returnObject.DataList[0].Id;
    this.seqinstruction = <SequenceInstructionItem>returnObject.DataList[0];
    this.seqinstruction.Parts = <SequenceInstructionPart[]>returnObject.DataList[0].Parts;
    this.showSpinner = false;
    this.isDirty = false;
  }

  loadSeqInstructionList(searchTerm: string) {
    this.instructionsList = null;
    this.seqInstrService.getInstructionList(searchTerm, this.user.SupplierNumber, this.user.ExtendedSupplierNumber, this.user.IsPartSupplierUser, this.user.InstructionType)
      .subscribe(returnObject => this.loadSeqInstructionListResponse(returnObject));
  }

  loadSeqInstructionListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg, 'SequneceInstructionComponent.loadSeqInstructionListResponse', ErrorTypeEnum.Error);
    }
    else {
      this.instructionsList = <AttributeListBE[]>returnObject.DataList;
    }
  }




info(message: string): void {
  this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
}





modal: any;
  changeGlobal(loggedInUser, oldUser, newUser, tbl, PartPI, PartSI,  MHNO_PM, MHNO_DU, oldIssuerUserId, oldApproverUserId) {

    // console.log(MHNO_PM);
    //  console.log(this.instruction);
    //  console.log(this.seqinstruction);

    // sessionStorage.setItem('isEdited', 'true');
    // sessionStorage.setItem('isApproved', 'true');

    if (this.instruction != null && this.instruction.isUser == true && this.instruction.isApprover == true  && this.instruction.IssuerUserId != null && this.instruction.IssuerUserId != "")
    {
    oldIssuerUserId = this.instruction.IssuerUserId;
    oldApproverUserId = this.instruction.ApproverUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");

    sessionStorage.setItem('isUser', 'true');
    sessionStorage.setItem('isApprover', 'true');

    }
    else if ( this.instruction != null && this.instruction.isUser == true && this.instruction.isApprover != true &&  this.instruction.IssuerUserId != null && this.instruction.IssuerUserId != "")
    {
    oldIssuerUserId = this.instruction.IssuerUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    sessionStorage.setItem('isUser', 'true');
    }
    else if (this.instruction != null && this.instruction.isApprover == true && this.instruction.isUser!= true  && this.instruction.ApproverUserId != null && this.instruction.ApproverUserId != "")
    {
    oldApproverUserId = this.instruction.ApproverUserId;
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");
    sessionStorage.setItem('isApprover', 'true');
    }
    else if (this.seqinstruction != null && this.seqinstruction.isUser == true && this.seqinstruction.isApprover == true  && this.seqinstruction.IssuerUserId != null && this.seqinstruction.IssuerUserId != "")
    {
    oldIssuerUserId = this.seqinstruction.IssuerUserId;
    oldApproverUserId = this.seqinstruction.ApproverUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");

    sessionStorage.setItem('isUser', 'true');
    sessionStorage.setItem('isApprover', 'true');

    }
    else if ( this.seqinstruction != null && this.seqinstruction.isUser == true && this.seqinstruction.isApprover != true &&  this.seqinstruction.IssuerUserId != null && this.seqinstruction.IssuerUserId != "")
    {
    oldIssuerUserId = this.seqinstruction.IssuerUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    sessionStorage.setItem('isUser', 'true');
    }
    else if (this.seqinstruction != null && this.seqinstruction.isApprover == true && this.seqinstruction.isUser!= true  && this.seqinstruction.ApproverUserId != null && this.seqinstruction.ApproverUserId != "")
    {
    oldApproverUserId = this.seqinstruction.ApproverUserId;
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");
    sessionStorage.setItem('isApprover', 'true');
    }
    else if (this.material != null && this.material.isInitialCreator == true && this.material.isResponsible == true &&  this.material.InitialCreatorUserId != null && this.material.InitialCreatorUserId != "")
    {
    oldIssuerUserId = this.material.InitialCreatorUserId;
    oldApproverUserId = this.material.ResponsibleUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");
    }
    else if (this.material != null && this.material.isInitialCreator == true && this.material.isResponsible != true &&  this.material.InitialCreatorUserId != null && this.material.InitialCreatorUserId != "")
    {
    oldIssuerUserId = this.material.InitialCreatorUserId;
    oldIssuerUserId = (oldIssuerUserId.toUpperCase()).replace(/\s/g, "");
    }
    else if (this.material != null && this.material.isResponsible == true && this.material.isInitialCreator != true &&  this.material.ResponsibleUserId != null && this.material.ResponsibleUserId != "")
    {
    oldApproverUserId = this.material.ResponsibleUserId;
    oldApproverUserId = (oldApproverUserId.toUpperCase()).replace(/\s/g, "");
    }
    // else if (this.material != null && this.material.InitialCreatorUserId != null && this.material.InitialCreatorUserId != "")
    // {
    // oldUser = this.material.InitialCreatorUserId;
    // oldUser = (oldUser.toUpperCase()).replace(/\s/g, "");
    // }
    else if (this.distrUnit != null && this.distrUnit.IssuerUserId != null && this.distrUnit.IssuerUserId != "")
    {
    oldUser = this.distrUnit.IssuerUserId;
    oldUser = (oldUser.toUpperCase()).replace(/\s/g, "");
    }
    newUser = (newUser.toUpperCase()).replace(/\s/g, "");
    console.log(oldUser, oldIssuerUserId, oldApproverUserId, newUser, PartPI, PartSI, MHNO_PM);

    if(!oldApproverUserId){
      oldApproverUserId = '';

    }
    if(!oldIssuerUserId){

      oldIssuerUserId = '';
    }


    this.changeIssuerService.changeIssuer(loggedInUser, oldUser, newUser, tbl, PartPI, PartSI, MHNO_PM, MHNO_DU, oldIssuerUserId, oldApproverUserId)
      .subscribe(resp => {
        if (tbl== 'global')
        this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} everywhere.`);
        else if(tbl=='PI' && PartPI != null && oldIssuerUserId != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId}, ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for Part PI : ${PartPI}`);
        else if(tbl=='PI' && PartPI != null && oldIssuerUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId} is now updated with New Issuer Id ${newUser} for Part PI : ${PartPI}`);
       else if(tbl=='PI' && PartPI != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for Part PI : ${PartPI}`);
       else if(tbl=='PI')
       this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} for all Packaging Instructions`);
       else if(tbl=='SI' && PartSI != null && oldIssuerUserId != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId}, ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for Part SI : ${PartSI}`);
        else if(tbl=='SI' && PartSI != null && oldIssuerUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId} is now updated with New Issuer Id ${newUser} for Part SI : ${PartSI}`);
       else if(tbl=='SI' && PartSI != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for Part SI : ${PartSI}`);
       else if(tbl=='SI')
       this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} for all Sequence Instructions`);
       else if (tbl== 'PM' && MHNO_PM != null && oldIssuerUserId != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId}, ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for MHNO : ${MHNO_PM}`);
       else if (tbl== 'PM' && MHNO_PM != null && oldIssuerUserId != null)
       this.info(`Old Issuer Id ${oldIssuerUserId} is now updated with New Issuer Id ${newUser} for MHNO : ${MHNO_PM}`);
       else if (tbl== 'PM' && MHNO_PM != null && oldApproverUserId != null)
       this.info(`Old Issuer Id ${oldApproverUserId} is now updated with New Issuer Id ${newUser} for MHNO : ${MHNO_PM}`);
       else if (tbl=='PM')
       this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} for all Packaging Materials`);
       else if (tbl=='DU' && MHNO_DU != null)
       this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} for MHNO : ${MHNO_DU}`);
       else if (tbl== 'DU')
       this.info(`Old Issuer Id ${oldUser} is now updated with New Issuer Id ${newUser} for all Distribution Units`);

      }, error => {
      });

  }

}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/change-issuer/change-issuer.component.ts